var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('FreeCellTable'),_c('Console'),(!!this.$store.state.FreeCellStore.lightBox)?_c('LightBox'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }